import React from 'react';
import RichTextContent, { RichTextContentProps } from './RichTextContent';

const Heading6 = ({ node }: RichTextContentProps) => {
  return (
    <h6>
      <RichTextContent node={node} />
    </h6>
  );
};

export default Heading6;
